import React from 'react';
import { CheckCircle2, XCircle, Upload, MessageSquare, DollarSign, Database, Activity, Truck } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale/es';

const ACTION_META = {
  crear_pago: { icon: DollarSign, tone: 'text-blue-600 dark:text-blue-400', ring: 'ring-blue-200 dark:ring-blue-900/60', bg: 'bg-blue-50 dark:bg-blue-950/40' },
  aprobar_pago: { icon: CheckCircle2, tone: 'text-emerald-600 dark:text-emerald-400', ring: 'ring-emerald-200 dark:ring-emerald-900/60', bg: 'bg-emerald-50 dark:bg-emerald-950/40' },
  rechazar_pago: { icon: XCircle, tone: 'text-red-600 dark:text-red-400', ring: 'ring-red-200 dark:ring-red-900/60', bg: 'bg-red-50 dark:bg-red-950/40' },
  subir_archivo: { icon: Upload, tone: 'text-slate-600 dark:text-slate-300', ring: 'ring-slate-200 dark:ring-slate-700', bg: 'bg-slate-100 dark:bg-slate-800/60' },
  enviar_mensaje: { icon: MessageSquare, tone: 'text-indigo-600 dark:text-indigo-400', ring: 'ring-indigo-200 dark:ring-indigo-900/60', bg: 'bg-indigo-50 dark:bg-indigo-950/40' },
  marcar_macrobase: { icon: Database, tone: 'text-teal-600 dark:text-teal-400', ring: 'ring-teal-200 dark:ring-teal-900/60', bg: 'bg-teal-50 dark:bg-teal-950/40' },
  bitacora_vehiculo: { icon: Truck, tone: 'text-amber-600 dark:text-amber-400', ring: 'ring-amber-200 dark:ring-amber-900/60', bg: 'bg-amber-50 dark:bg-amber-950/40' },
};

function actionTitle(action) {
  switch (action) {
    case 'crear_pago': return 'Solicitud creada';
    case 'aprobar_pago': return 'Pago aprobado';
    case 'rechazar_pago': return 'Pago rechazado';
    case 'subir_archivo': return 'Archivo adjunto';
    case 'enviar_mensaje': return 'Nuevo mensaje';
    case 'marcar_macrobase': return 'Actualización ERP';
    case 'bitacora_vehiculo': return 'Bitácora del vehículo';
    default: return 'Actividad';
  }
}

export default function PaymentTimeline({ logs = [] }) {
  // logs asc por created_at (backend ya lo devuelve así)
  if (!logs || logs.length === 0) {
    return (
      <div className="text-center py-6" data-testid="timeline-empty">
        <Activity className="h-8 w-8 text-slate-300 dark:text-slate-700 mx-auto mb-2" />
        <p className="text-xs text-slate-500 dark:text-slate-500">Sin eventos aún</p>
      </div>
    );
  }

  return (
    <ol className="relative border-l border-slate-200 dark:border-slate-800 ml-3 space-y-4" data-testid="payment-timeline">
      {logs.map((log) => {
        const meta = ACTION_META[log.action] || { icon: Activity, tone: 'text-slate-500 dark:text-slate-400', ring: 'ring-slate-200 dark:ring-slate-700', bg: 'bg-slate-100 dark:bg-slate-800/60' };
        const Icon = meta.icon;
        let when = '';
        try {
          when = format(new Date(log.created_at), "dd MMM yyyy 'a las' HH:mm", { locale: es });
        } catch { /* ignore */ }
        return (
          <li key={log.id} className="ml-6" data-testid={`timeline-item-${log.id}`}>
            <span className={`absolute -left-[13px] h-6 w-6 rounded-full ${meta.bg} ring-4 ring-white dark:ring-slate-900 flex items-center justify-center`}>
              <Icon className={`h-3.5 w-3.5 ${meta.tone}`} />
            </span>
            <div className="flex items-baseline gap-2 flex-wrap">
              <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">{actionTitle(log.action)}</p>
              <span className="text-[11px] text-slate-500 dark:text-slate-500">·</span>
              <span className="text-[11px] text-slate-500 dark:text-slate-500">{log.user_name}</span>
            </div>
            <p className="text-[11px] text-slate-400 dark:text-slate-600 mt-0.5">{when}</p>
            {log.details && (
              <p className="mt-1 text-xs text-slate-600 dark:text-slate-400 leading-relaxed">{log.details}</p>
            )}
          </li>
        );
      })}
    </ol>
  );
}
